<div
  class="flex flex-row justify-center soft-pull-to-refresh-indicator"
  [ngStyle]="{ opacity: getOpacity }"
  >
  @if (!showSpinner) {
    <span
      class="fa-regular fa-arrow-down transition-opacity-rotation"
      style="align-self: center; justify-self: center"
      [ngStyle]="{ opacity: getOpacity, transform: getTransform }"
      >
    </span>
  }
  @if (showSpinner) {
    <soft-loading-spinner
      style="align-self: center; justify-self: center"
      [ngStyle]="{ opacity: getOpacity }"
      @enterLeave
      >
    </soft-loading-spinner>
  }
</div>
